import React, { useState, useEffect } from "react";
import {
  Icon
} from 'antd';
import UserCardList from "./UserCardList";
import CardRegistration from "./CardRegistration";

const FeedWithCard = ({orderId, creditNote, creditNoteId, refund, redirectionURL, amount,mangoPay }) => {
  return <div className={"flex justify-center flex-col"}
              style={{"padding": "1.5rem", "height": "100%"}}>
    <div style={{"maxHeight": "150px", "overflowY": "scroll"}}
         className={"mb-3"}>
        <UserCardList
          isCommunity={0}
          orderId={orderId}
          isCreditNote={creditNote}
          creditNoteId={creditNoteId}
          isRefund={refund}
          redirectionURL={redirectionURL}
          amount={amount}
        />
      </div>
      <CardRegistration
        isCommunity={0}
        orderId={orderId}
        isCreditNote={creditNote}
        creditNoteId={creditNoteId}
        isRefund={refund}
        redirectionURL={redirectionURL}
        amount={amount}
      />
      {mangoPay.showSpinner ?
        <div className="div-fetching-file flex items-center justify-center ">
          <Icon type="sync" spin style={{fontSize: "50px"}}/>
        </div> : null
      }
    </div>;
}

export default FeedWithCard;




// WEBPACK FOOTER //
// ./app/components/Admin/FeedMangoWallet/FeedWithCard.js